// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rYAYe","importantInfo":"styles_importantInfo__uDWDW"};